import { Component, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
// import { User } from 'app/shared/services/user/user.model';
import { UserService } from 'app/shared/services/user/user.service';
import { UserApplicationProperties, RoleType } from 'app/shared/services/user/user-application-properties.model';
import { Session } from 'app/shared/services/session/session.service';
import { Application } from 'app/shared/services/app/application/application.model';
import { ApplicationService } from 'app/shared/services/app/application/application.service';
import { AppUsersBuilderComponent } from 'app/shared/components/app-users-builder/app-users-builder.component';
import { LoaderButton } from 'app/shared/components/loader-button/loader-button.component';
import { TogglitScreen } from 'app/screens/togglit-screen';
import { Router } from '@angular/router';
import { AppUser } from 'app/shared/services/user/app-user.model';

@Component({
  selector: 'tog-app-users-editor',
  templateUrl: './app-users-editor.component.html',
  styleUrls: ['./app-users-editor.component.scss']
})
export class AppUsersEditorComponent extends TogglitScreen {
  UserApplicationProperties = UserApplicationProperties;
  RoleType = RoleType;
  app: Application;
  usersAlreadyInApp: AppUser[] = [];

  usersToAdd: any[] = [];

  userToEdit: any;
  userToEditIndex: number;
  nextUserToEditIndex: number;
  userToDeleteIndex: number;

  userInList: boolean = false;
  userInApp: boolean = false;
  userInListForEdit: boolean = false;
  userInAppForEdit: boolean = false;
  maxUsersReached: boolean = false;

  @Output('updateUsers') updateUsers = new EventEmitter();
  @ViewChild('deleteUserButton') deleteUserButton: ElementRef;
  @ViewChild('editBuilder') editBuilder: AppUsersBuilderComponent;
  @ViewChild('addBuilder') addBuilder: AppUsersBuilderComponent;

  @ViewChild('confirmDeleteUserButton') confirmDeleteUserButton: LoaderButton;

  constructor(private _userService: UserService,
              protected _session: Session,
              protected _router: Router,
              protected _appService: ApplicationService) {
                super();
              }

  afterInit() {
    return this._userService.getAllAppUsers(this.app.sys_name, false)
    .then((users: AppUser[]) => {
      this.usersAlreadyInApp = users;
    });
  }

  getFeaturesString(features: any[]) {
    let featureString = '';
    features.forEach((feature) => {
      if (feature.selected) {
        featureString += feature.display_name + ', ';
      }
    });
    featureString = featureString.slice(0, -2); // removes last space and comma
    return featureString;
  }

  checkForUserInGivenList(newUser: any, listToCheck: any[]) {
    let userExists: boolean = false;
    listToCheck.forEach((user) => {
      if (user.email == newUser.email && this.userToEdit != user) {
        userExists = true;
      }
    });
    return userExists;
  }

  addUserToList(newUser: any) {
    this.maxUsersReached = false;
    this.userInApp = false;
    this.userInList = false; // reset
    if (this.checkForUserInGivenList(newUser, this.usersToAdd)) {
      this.userInList = true;
      return;
    } else if (this.checkForUserInGivenList(newUser, this.usersAlreadyInApp)) {
      this.userInApp = true;
      return;
    }
    if (this.usersToAdd.length + 1 > 50) {
      this.maxUsersReached = true;
      return;
    }

    // otherwise add to the user list
    this.usersToAdd.push(newUser);
    this.updateUsers.emit(this.usersToAdd);
    this.addBuilder.resetForm();
  }

  updateUserInList(newUser: any) {
    this.userInAppForEdit = false;
    this.userInListForEdit = false; // reset
    if (this.checkForUserInGivenList(newUser, this.usersToAdd)) {
      this.userInListForEdit = true;
      return;
    } else if (this.checkForUserInGivenList(newUser, this.usersAlreadyInApp)) {
      this.userInAppForEdit = true;
      return;
    }

    // otherwise update user
    this.usersToAdd[this.userToEditIndex].email = newUser.email;
    this.usersToAdd[this.userToEditIndex].role = newUser.role;

    // updates or adds features if it's a Manager...
    if (newUser.features) {
      this.usersToAdd[this.userToEditIndex].features = newUser.features
    } else if (this.usersToAdd[this.userToEditIndex].features) {
      // ...and remove features array from the object entirely if it used to be a Manager and now is not
      delete this.usersToAdd[this.userToEditIndex].features;
    }
    this.userToEdit = null; // we're done editing, so hide the edit builder
    this.updateUsers.emit(this.usersToAdd);
  }

  editUser(userIndex: number) {
    // if we're alredy editing a user save which user got clicked on so we know who to edit next
    if (this.userToEdit) {
      this.nextUserToEditIndex = userIndex;
      this.editBuilder.cancelButton(); // display cancel modal if changes have been made
    } else {
      this.userToEdit = this.usersToAdd[userIndex];
      this.userToEditIndex = userIndex;
    }
  }

  deleteUser(userIndex: number) {
    this.userToDeleteIndex = userIndex;
    this.deleteUserButton.nativeElement.click();
  }

  confirmDeleteUser(userIndex: number) {
    this.usersToAdd.splice(userIndex, 1);
    this.updateUsers.emit(this.usersToAdd);
    this.userToDeleteIndex = null;
    this.confirmDeleteUserButton.setConfirmed();
  }

  cancelEditingUser() {
    // if we have a saved user to go to next go there
    if (this.nextUserToEditIndex != null) {
      this.userToEdit = this.usersToAdd[this.nextUserToEditIndex];
      this.userToEditIndex = this.nextUserToEditIndex;
      this.nextUserToEditIndex = null; // reset
    } else {
      // otherwise just close the builder
      this.userToEdit = null;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/app-users-editor/app-users-editor.component.ts